import { LiveblogPost } from '@src/interfaces';
import fetchJson from '@src/utils/api/fetch';

export type LiveblogPostsResponse = {
  posts: LiveblogPost[];
  total: number;
}

const fetchLiveblogPosts = (
  liveblogId: string,
  offset: number,
  limit: number,
): Promise<LiveblogPostsResponse> => fetchJson<LiveblogPostsResponse>({
  url: `/api/headless/p7s1p4/liveblog_posts/${liveblogId}?offset=${offset}&limit=${limit}`,
}).then(response => response.body)
  .catch(err => {
    console.error('fetchLiveblogPosts', err);
    return { posts: [], total: 0 };
  });

export default fetchLiveblogPosts;
